import AnnouncementBar from '@algbra/ui/components/AnnouncementBar/AnnouncementBar'
import Button from '@algbra/ui/components/Button/Button'
import Caption from '@algbra/ui/components/Caption/Caption'
import FreeText from '@algbra/ui/components/FreeText/FreeText'
import { Column, Container, Row } from '@algbra/ui/components/Grid/Grid'
import Heading from '@algbra/ui/components/Heading/Heading'
import { VAlign } from '@algbra/ui/enums/align'
import {
  MEDIA_QUERY_MOBILE,
  useMediaQuery,
} from '@algbra/ui/hooks/useMediaQuery'
import { getIconByName } from '@algbra/ui/icons'
import '@algbra/ui/styles/globals.scss'
import { graphql, navigate } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import DialogDecoded from '../components/DialogDecoded/DialogDecoded'
import EarlyAccess from '../components/EarlyAccess/EarlyAccess'
import Footer from '../components/Footer/Footer'
import Header from '../components/Header/Header'
import HeaderContainer from '../components/HeaderContainer/HeaderContainer'
import MetaTags from '../components/MetaTags/MetaTags'
import { getMetaTags } from '../utils/metaTags'
import HomeZoneRenderer from '../zones/HomeContentZone'
import styles from './home.module.scss'
import { ReactComponent as StoreQrIcon } from '../images/home/storeQR-v2.svg'
import { ReactComponent as MedalIcon } from '../images/home/medal.svg'
import { ReactComponent as ShieldStarIcon } from '../images/home/shield-star.svg'
import { ReactComponent as PricelessPlanetCoalitionLogo } from '../images/home/priceless-planet-coalition.svg'
import { ReactComponent as CertifiedBCorpLogo } from '../images/home/certified-b-corporation-2.svg'
import classNames from 'classnames'

export default function LayoutHome({ pageContext, data, location }) {
  const isMobile = useMediaQuery(MEDIA_QUERY_MOBILE)
  const zones = data.strapiGQL.page.contentZones
  const title = data.strapiGQL.page.title
  const subtitle = data.strapiGQL.page.subtitle

  return (
    <div>
      <MetaTags {...getMetaTags(pageContext)} />
      <HeaderContainer>
        <AnnouncementBar
          title="Algbra Labs bolsters diaspora-focused digital banking leadership with Isbank and RUUT strategic partnership"
          to="/news/algbra-labs-and-moka-united-the-fintech-subsidiary-of-isbank-announce-strategic-partnership-to-launch-ruut-in-the-uk/"
          target="_self"
          category="Press Release"
          bg="light"
        />
        <Header
          hasBorder={isMobile}
          hasBg={false}
          hasAnnouncement={true}
          forceTheme="darkTranslucent"
        />

        <Container
          fluid={false}
          className={styles.zIndexed}
          role="complementary"
        >
          <Row vAlign={VAlign.CENTER} className={styles.bannerArea}>
            <Column size={12} sm={8} className={styles.content}>
              <div>
                <Heading level={1} type="xl" className={styles.header}>
                  <div dangerouslySetInnerHTML={{ __html: title }}></div>
                </Heading>
                <FreeText
                  className={classNames(styles.text, styles.subtitle)}
                  innerHTML={subtitle}
                  color="white"
                >
                  {subtitle}
                </FreeText>
              </div>

              <Button
                className={styles.downloadButton}
                size="normal"
                onClick={() => navigate('/download')}
                theme="light"
              >
                Open an Algbra Account
              </Button>

              <div className={styles.downloadAppContainer}>
                <div className={styles.qrIconWrapper}>
                  <StoreQrIcon />
                </div>

                <p className={styles.qrDescription}>Scan to Download</p>
              </div>
              <div className={styles.bottomContainer}>
                <div className={styles.bottomBlock}>
                  <div className={styles.bottomItem}>
                    <MedalIcon />
                    <div>
                      <p className={styles.bottomItemTitle}>
                        Winner of the 2023 Pay360 Award for Best ESG Initiative
                        in Payments
                      </p>
                    </div>
                  </div>
                  <div className={styles.bottomItem}>
                    <ShieldStarIcon />
                    <div>
                      <p className={styles.bottomItemTitle}>
                        Algbra is regulated by the Financial Conduct Authority
                        (FCA) in the UK.
                      </p>
                    </div>
                  </div>
                </div>
                <div className={styles.certificationContainer}>
                  <PricelessPlanetCoalitionLogo />
                  <CertifiedBCorpLogo />
                </div>
              </div>
            </Column>
          </Row>
        </Container>
      </HeaderContainer>

      {zones && <HomeZoneRenderer zones={zones} location={location} />}
      <Footer />
    </div>
  )
}

export const pageQuery = graphql`
  query ($id: ID!) {
    strapiGQL {
      page(id: $id) {
        ...StrapiGQL_PagesWithContentZones
      }
    }
  }
`
